import React from "react";
import { Formik, Field, Form } from "formik";
import {
  TextField,
  Loading,
  MultiSelect,
  Select,
  PersianDataPicker,
} from "components/form";
import { required, validationWrapper, isUserName } from "lib/formValidations";
import {
  transformTranslateFromValues,
  transformTranslateServerValues,
  dateTimeToserver,
} from "lib/helpers";
import Modal from "components/Modal";
import { useCore } from "store/core";
import { TextArea } from "components/form";
import cleanObject from "utils/editHelper";
import { GalleryField } from "components/form";
import MultySearchSelect from "utils/MultySearchSelect";
import initItem from "utils/initItem";
import extractValues from "utils/extractValues";
import MetaDataComponent from "utils/MetaDataComponent";
import TextFieldSlug from "components/form/TextFieldSlug";
// components
const statuss = [
  { label: "رزرو شده", value: "registration" },
  { label: "درحال اجرا", value: "ongoing" },
  { label: "تکمیل شده", value: "completed" },
  { label: "کنسل شده", value: "cancelled" },
];

const currencys = [
  { label: "دلار", value: "USD" },
  { label: "ریال", value: "IRR" },
];

const defaultLanguages = [
  { label: "فارسی", value: "Persian" },
  { label: "انگلیسی", value: "English" },
];

const levels = [
  { label: "جام داخلی", value: "domesticCup" },
  { label: "جام بین المللی", value: "internationalCup" },
  { label: "لیگ داخلی", value: "domesticLeague" },
];

const sportTypes = [
  { label: "فوتبال", value: "football" },
  { label: "بسکتبال", value: "basketball" },
  { label: "تنیس", value: "tennis" },
  { label: "کریکت", value: "cricket" },
  { label: "والیبال", value: "volleyball" },
  { label: "هاکی", value: "hockey" },
];

export default function Edit(props) {
  const core = useCore();
  const { show, item } = props;

  const config = {
    referees: {
      valueField: "id",
      labelFields: ["translations.fa.name", "translations.fa.lastName"],
    },
    stadiums: {
      valueField: "id",
      labelFields: ["translations.fa.name"],
    },
    matches: {
      valueField: "id",
      labelFields: [
        "homeTeam.translations.fa.name",
        "awayTeam.translations.fa.name",
      ],
    },
    teams: {
      valueField: "id",
      labelFields: ["translations.fa.name"],
    },
  };
  const updatedItem = initItem(item, config);

  return (
    <>
      <Modal show={props.show} handleClose={props.close} title={props.title}>
        <Formik
          initialValues={updatedItem}
          onSubmit={async (values, { setSubmitting }) => {
            if (values.birthday)
              values.birthday = dateTimeToserver(values.birthday, "YYYY-MM-DD");

            const clean = cleanObject(values, [
              "id",
              "uuid",
              "updatedAt",
              "createdAt",
              "createdBy",
              "news",
              "videos",
              "statistics",
            ]);
            const result = extractValues(clean, [
              "teams",
              "matches",
              "stadiums",
              "referees",
            ]);

            await props.submit(result, item.id);
            props.close();
            setSubmitting(false);
          }}
          enableReinitialize
        >
          {({ isSubmitting, dirty, values, setFieldValue }) => (
            <Form>
              <div className="modal-body gap-y-3">
                <div className="intro-x grid md:grid-cols-2 md:gap-3">
                  <Field
                    placeholder="نام"
                    label="نام :"
                    name="translations.fa.name"
                    slugFieldName="translations.fa.slug"
                    component={TextFieldSlug}
                  />
                  <Field
                    placeholder="نام(en)"
                    label="نام (en):"
                    name="translations.en.name"
                    slugFieldName="translations.en.slug"
                    component={TextFieldSlug}
                  />
                  <Field
                    placeholder="نام کوتاه"
                    label="نام کوتاه :"
                    name="translations.fa.shortName"
                    component={TextField}
                  />
                  <Field
                    placeholder="نام کوتاه(en)"
                    label="نام کوتاه (en):"
                    name="translations.en.shortName"
                    component={TextField}
                  />

                  <Field
                    placeholder="توضیحات"
                    label="توضیحات :"
                    name="translations.fa.description"
                    component={TextArea}
                  />
                  <Field
                    placeholder="توضیحات(en)"
                    label="توضیحات(en) :"
                    name="translations.en.description"
                    component={TextArea}
                  />

                  <Field
                    placeholder="کشور"
                    label="کشور :"
                    name="translations.fa.primaryCountry"
                    component={TextField}
                  />
                  <Field
                    placeholder="کشور(en)"
                    label="کشور(en) :"
                    name="translations.en.primaryCountry"
                    component={TextField}
                  />

                  <Field
                    placeholder="نامک"
                    label="نامک:"
                    name="translations.fa.slug"
                    component={TextField}
                  />
                  <Field
                    placeholder="نامک(en)"
                    label="نامک(en) :"
                    name="translations.en.slug"
                    component={TextField}
                  />

                  <div className="intro-y">
                    <Field
                      label="وضعیت لیگ :"
                      name="status"
                      component={Select}
                      options={statuss}
                      className="w-full px-3 py-2 border rounded"
                    />
                  </div>

                  <div className="intro-y">
                    <Field
                      label="ارز لیگ :"
                      name="currency"
                      component={Select}
                      options={currencys}
                      className="w-full px-3 py-2 border rounded"
                    />
                  </div>

                  <div className="intro-y">
                    <Field
                      label="زبان لیگ :"
                      name="defaultLanguage"
                      component={Select}
                      options={defaultLanguages}
                      className="w-full px-3 py-2 border rounded"
                    />
                  </div>

                  <Field
                    label=" داوران:"
                    name="referees"
                    component={MultySearchSelect}
                    searchFields="translations.name"
                    collectionName="referee"
                    showFields="translations.name"
                    className="w-full px-3 py-2 border rounded"
                  />

                  <div className="intro-y">
                    <span>مجموع جوایز لیگ :</span>
                    <Field
                      label="مجموع جوایز لیگ  : "
                      name="prizePool"
                      component="input"
                      type="number"
                      className="w-full px-3 py-2 border rounded"
                    />
                  </div>

                  <Field
                    label=" استادیوم ها:"
                    name="stadiums"
                    component={MultySearchSelect}
                    searchFields="translations.name"
                    collectionName="stadium"
                    showFields="translations.name"
                    className="w-full px-3 py-2 border rounded"
                  />

                  <div className="intro-y">
                    <Field
                      label="سطح لیگ :"
                      name="level"
                      component={Select}
                      options={levels}
                      className="w-full px-3 py-2 border rounded"
                    />
                  </div>

                  <Field
                    label="وضعیت :"
                    name="isActive"
                    component={Select}
                    options={[
                      { value: true, label: "فعال" },
                      { value: false, label: "غیر فعال" },
                    ]}
                    className="w-full px-3 py-2 border rounded"
                  />

                  <Field
                    label=" مسابقات:"
                    name="matches"
                    component={MultySearchSelect}
                    searchFields="homeTeam.translations.name,awayTeam.translations.name"
                    collectionName="match"
                    showFields="homeTeam.translations.name,awayTeam.translations.name,matchDate"
                    className="w-full px-3 py-2 border rounded"
                  />

                  <Field
                    label=" تیم ها:"
                    name="teams"
                    component={MultySearchSelect}
                    searchFields="translations.name"
                    collectionName="team"
                    showFields="translations.name"
                    className="w-full px-3 py-2 border rounded"
                  />

                  <div className="intro-y">
                    <Field
                      label="نوع ورزش :"
                      name="sportType"
                      component={Select}
                      options={sportTypes}
                      className="w-full px-3 py-2 border rounded"
                    />
                  </div>

                  <div className="intro-y">
                    <Field
                      label="دسته بندی :"
                      name="category"
                      component={Select}
                      options={core.categories || []}
                      className="w-full px-3 py-2 border rounded"
                    />
                  </div>

                  <div className="user-datepicker">
                    <Field
                      label="تاریخ شروع :"
                      name="startDate"
                      component={PersianDataPicker}
                    />
                  </div>

                  <div className="user-datepicker">
                    <Field
                      label="تاریخ پایان :"
                      name="endDate"
                      component={PersianDataPicker}
                    />
                  </div>
                </div>
                <div className="w-full flex justify-between">
                  <div className="w-full">
                    <Field
                      label="لوگو"
                      name="logo"
                      dataType="id"
                      component={GalleryField}
                    />
                  </div>
                </div>

                <div className="w-full flex justify-between mt-10">
                  <div className="w-full">
                    <Field
                      label="بنر"
                      name="banner"
                      dataType="id"
                      component={GalleryField}
                    />
                  </div>
                </div>

                <MetaDataComponent
                  values={values}
                  setFieldValue={setFieldValue}
                  type="League"
                />
              </div>

              <div className="modal-footer text-right">
                <button
                  className="btn btn-primary w-20"
                  type="submit"
                  disabled={!!(isSubmitting || !dirty)}
                >
                  {" "}
                  {isSubmitting ? <Loading /> : "ذخیره"}
                </button>
                <button
                  type="button"
                  disabled={isSubmitting}
                  onClick={props.close}
                  className="btn btn-outline-secondary w-20 mr-1"
                >
                  انصراف
                </button>
              </div>
            </Form>
          )}
        </Formik>
      </Modal>
    </>
  );
}
